import React, { useEffect, useState } from 'react';
import './Footer.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import { faAt, faBuilding, faEnvelope, faPhone, faShieldAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

import { useForm } from 'react-hook-form';
import { isEmail } from '../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import service from '../../services/site';
import { actions as actionsHeader } from '../../redux/actions/site';
import lekaPopEmail from './../../assets/images/lekaPopEmail.png';
import { VERSION } from '../../config/constants';

const Footer = props => {

    const { register, handleSubmit, errors, reset } = useForm();
    const dispatch = useDispatch();
    const [showPopEmail, setShowPopEmail] = useState(false);
    const profile = useSelector(state => state.auth.profile);

    const openWhats = _ => {
        const url = `https://api.whatsapp.com/send?1=pt_BR&phone=5511942023397&text`;
        window.open(url, '_blank');
    }

    const openFacebook = _ => {
        const url = `https://www.facebook.com/lekacatalogos/`;
        window.open(url, '_blank');
    }
    const openYoutube = _ => {
        const url = `https://www.youtube.com/channel/UCcvhAZOmHr0iCbXiVcMzTlw`;
        window.open(url, '_blank');
    }
    const openInstagram = _ => {
        const url = `https://www.instagram.com/lekacatalogos/`;
        window.open(url, '_blank');
    }

    const cadastraEmail = async data => {

        dispatch(actionsHeader.setLoadingMsg("Enviando..."));
        const res = await service.subscribeEmail(data);
        dispatch(actionsHeader.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionsHeader.setLoadingMsg(""));
            setShowPopEmail(false);
            reset({});
        }, 3000);
    }

    const renderPop = () => {
        return (
            <div className="popemail">
                <div className="body">
                    <div className="close">
                        <FontAwesomeIcon icon={faTimes} onClick={() => setShowPopEmail(false)} />
                    </div>
                    <div className="imagem">
                        <img src={lekaPopEmail} alt="" />
                    </div>
                    <h3>
                        Receba as novidades!
                    </h3>
                    <form onSubmit={handleSubmit(cadastraEmail)}>
                        <input type="text" name="nome" placeholder="Seu nome" className={errors.nome ? 'erro' : ''} 
                            ref={register({ required: true })} />
                        <input type="text" name="email" placeholder="Seu e-mail" className={errors.email ? 'erro' : ''} 
                            ref={register({ required: true, validate: { isEmail: value => isEmail(value) } })} />
                        <input type="text" name="telefone" placeholder="Seu Whatsapp" className={errors.telefone ? 'erro' : ''} 
                            ref={register({ required: true })} />
                        <button type="submit">Cadastrar</button>
                    </form>
                </div>
            </div>
        )
    }

    useEffect(()=>{
        const run = () =>{
            if(profile.nome === ""){
                setTimeout(setShowPopEmail,5000,true);
            }
        }
        run();
    },[profile.nome]);

    return (
        <div className="footer">
            
                <div className="seguirNasRedes">
                    {/* Receba nossas promoções e novidades por e-mail */}
                    <span>Nos siga nas redes sociais</span>
                    <div className="redes">
                        <div className="social youtube" onClick={openYoutube}><FontAwesomeIcon icon={faYoutube} /></div>
                        <div className="social facebook" onClick={openFacebook}><FontAwesomeIcon icon={faFacebook} /></div>
                        <div className="social instagram" onClick={openInstagram}><FontAwesomeIcon icon={faInstagram} /></div>
                        <div className="social whatsapp" onClick={openWhats}><FontAwesomeIcon icon={faWhatsapp} /></div>
                    </div>
                    
                </div>
            
            <div className="barraBranca">
                <div className="container">
                    <div className="coluna displayColumns">
                        <div className="logo">
                            <div className="brand">Leka Catálogos</div>
                            <div className="slogan">Muito mais que uma distribuidora</div>
                        </div>

                        <div className="enderecoTel">
                            <div className="coluna displayColumns">
                                <div className="endereco">
                                    <div>Av. Otávio Braga de Mesquita, 1773<br /> salas 1 e 3</div>
                                    <div>Vila Barros - Guarulhos - SP</div>
                                </div>
                            </div>
                            <div className="coluna">
                                <div className="redes">
                                    <div className="social"><FontAwesomeIcon icon={faWhatsapp} /> (11) 94202-3397 </div>
                                    <div className="social"><FontAwesomeIcon icon={faPhone} /> (11) 4965-0655 </div>
                                    <div className="social"><FontAwesomeIcon icon={faAt} /> contato@lekacatalogos.com.br </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="coluna mapa">
                        <iframe title="Mapa" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1830.1516598617939!2d-46.508475!3d-23.449521!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3aa0804fc60f330!2sLeka%20Cat%C3%A1logos!5e0!3m2!1sen!2sus!4v1599001332438!5m2!1sen!2sus" width="100%" height="260" frameBorder="0" allowFullScreen={false}></iframe>
                    </div>
                </div>

            </div>

            <div className="barra">
                <div className="container">
                    <div className="coluna topicos">
                        <div className="topico">
                            <label><FontAwesomeIcon icon={faBuilding} /> A Leka</label>
                            <div className="items">
                                <Link to="/sobre">Sobre nós</Link>
                                <Link to="/catalogos">Catálogos</Link>
                                <Link to="/duvidas">Dúvidas</Link>
                            </div>
                        </div>

                        <div className="topico">
                            <label><span className="material-icons">face</span> Área da consultora</label>
                            <div className="items">
                                <Link to="/painel/home">Painel</Link>
                                <Link to="/meus-pedidos">Meu pedidos</Link>
                            </div>
                        </div>

                        <div className="topico">
                            <label><FontAwesomeIcon icon={faEnvelope} /> Contato</label>
                            <div className="items">
                                <Link to="/faleconosco">Fale conosco</Link>
                            </div>
                        </div>

                        <div className="topico">
                            <label><FontAwesomeIcon icon={faShieldAlt} /> Segurança</label>
                            <div className="items">
                                <span>Site 100% seguro</span>
                                <span>Proteção contra invasão</span>
                                <span>Site seguro com criptografia (SSL)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="direitos">
                    © {new Date().getFullYear()} - Todos os direitos reservados - v{VERSION}
                </div>
            </div>
            {showPopEmail && renderPop()}
        </div>
    )
};

export default Footer;